import React, { useRef, useContext, useEffect } from 'react';
import { Waypoint } from 'react-waypoint';
import ddt from '@wix/da-ddt';
import { isActiveThread, updateCommentOffset } from '../../helpers';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SimpleThread from '../SimpleThread';
import { ThreadProps } from '../../types';
import OffsetTrackingComment from '../../_partials/OffsetTrackingComment';

const logger = ddt.createLogger('comments');

const resetCommentOffset = () => updateCommentOffset();

const OffsetTrackingCommentThread: React.FC<ThreadProps> = ({ className, ...props }) => {
  const threadStartRef = useRef<HTMLDivElement>(null);
  const isMobile = useContext(MobileContext);

  useEffect(() => {
    const threadStart = threadStartRef.current;
    if (isActiveThread(props.commentableTypeId, props.commentableItemId) && threadStart) {
      logger.log('Scrolling to active thread');
      scrollIntoViewWithHeader(threadStart, isMobile);
    }
  }, [isMobile, props.commentableTypeId, props.commentableItemId]);

  return (
    <Waypoint onLeave={resetCommentOffset}>
      <div className={className} ref={threadStartRef}>
        <SimpleThread {...props} commentComponent={OffsetTrackingComment} />
      </div>
    </Waypoint>
  );
};
OffsetTrackingCommentThread.displayName = 'OffsetTrackingCommentThread';

export default OffsetTrackingCommentThread;
